/**
 * @typedef {{
 *  traceName?: string;
    startTime: number;
    duration: number;
    options?: {
        metrics?: { [key: string]: number };
        attributes?: { [key: string]: string };
    };
   }} TransPortOptions

   @typedef {{
    endPoints: Array<string>; // firebase, sa, prometheus
    message: Message;
    traceName?: string;
    startTime?: number;
   }} Event
 */

import * as firebase from 'firebase/app';

import runtime from '../utils/runtime';
import { isMetricsValid, isAttributesValid, filterAttributes } from '../filters/index';
import logger from '../logger/index';
import { checkTraceName } from '../utils/trace';
import { getRouteName } from '../utils/path';
import { currentRouteChannelEnabled } from '../utils';
import { FIREBASE_ENDPOINT_NAME } from '../constants';

/**
 * 
 * @param {Event} event
 */
function formatEvent(event) {
  const { metrics, attributes } = event.message;
  const { duration, ...restMetrics } = metrics;
  const filteredAttributes = filterAttributes(FIREBASE_ENDPOINT_NAME, event.type, attributes);

  const formatted = {
    traceName: event.traceName,
    startTime: event.startTime || performance.timing.navigationStart,
    duration: metrics.duration,
    options: {
        metrics: {
          ...restMetrics,
        },
        attributes: {
          ...filteredAttributes,
        },
    },
  };

  return formatted;
}

/**
 * 
 * @param {TransPortOptions} options
 * @param {function} metricsPredicate 
 */
function readyTransport(options, metricsPredicate) {
  if (!currentRouteChannelEnabled(FIREBASE_ENDPOINT_NAME)) {
    return false;
  }
  let traceName = options.traceName

  if (!checkTraceName(traceName)) {
    logger.error('trace name 不合法', traceName)
    return false
  }

  if (options.options && !isAttributesValid(options.options.attributes)) {
    logger.error('不合法的 attributes', options.options.attributes, traceName)
    return false
  }

  if (options.options && !isMetricsValid(options.options.metrics, metricsPredicate)) {
    logger.error('不合法的 metrics', options.options.metrics, traceName)
    return false
  }

  const shouldLog = runtime.get('shouldLog')
  const shouldReport = runtime.get('shouldReport')

  if (shouldLog) {
    logger.info(
`
[performance-collect]:
  trace: ${traceName},
  duration: ${options.duration || 0},
  options: ${JSON.stringify(options.options, null, 4)}
`
    )
  }

  if (shouldReport) {
    transport({
      ...options,
      traceName,
    })
  }

  return true
}

/**
 * 
 * @param {TransPortOptions} options 
 */
function transport({ traceName, startTime, duration, options }) {
  const pref = firebase.performance()
  const trace = pref.trace(traceName)
  trace.record(startTime || Date.now(), duration, options)
}

/**
 * 
 * @param {Array<Event>} events 
 */
export function handleEvents(events) {
  if (!firebase.apps.length) {
    logger.error('firebase 未初始化');
    return false;
  }

  if (!currentRouteChannelEnabled(FIREBASE_ENDPOINT_NAME)) {
    return false;
  }

  events.forEach((event) => {
    const e = formatEvent(event);
    readyTransport(e, event.message.metricsPredicate);
  });
}
